import CommonWrapper from 'screens/CommonWrapper';
import React from 'react';
import Background from 'baseline-ui/background';
import { BACKGROUND_MODES } from 'common/consts/consts';
import Intro from './Intro';
import HelpSection from './HelpSection';
import PreferSection from './PreferSection';
import BussinessAndProfessinalImageStyled from './BussinessAndProfessinalImageStyled';
import Favepage_Hero_Business from 'assets/images/Favepage_Hero_Business.jpg';

const BusinessAndProfessionalsScreen = () => {
    return (
        <CommonWrapper>
                <BussinessAndProfessinalImageStyled src={Favepage_Hero_Business}/>
                <HelpSection />
                <PreferSection />
        </CommonWrapper>
    );
};

export default BusinessAndProfessionalsScreen;
